import React from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull, formatDate, isDatePastInMoscow } from '../../Utils/GlobalUtils';

import InfoMessage from '../InfoMessage';
import LoadingBlock from '../LoadingBlock';
import WarningPanel from '../WarningPanel';

import styles from '../../styles/Home.module.css';

import { ReactComponent as ArrowRight } from '../../icons/chevron-right.svg';
import IconContainer from '../IconContainer';

const AMHome = ({ userId }) => {
    const { openTimeModal } = useTimeModal();
    const location = useLocation();
    const navigate = useNavigate();

    const [formInfo, setFormInfo] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);
        setWarning('');

        axios.get(`/api/get-home-user-info?user_id=${userId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then((response) => {
            setFormInfo(response.data);
        })
        .catch((error) => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, userId]);

    return (
        <div className='pageWrapper'>
            <InfoMessage />
            {/* <div className='horizontalContainer'>
                <div className={`${styles.colorSquarePanel} ${styles.yellow}`}>
                    <h1 className={styles.mainHeadline}>Заявки</h1>
                    <h2 className={styles.primaryHeadline}>{loading ? <LoadingBlock width="60px" height="28px" /> : formatNull(formInfo.count_applications)}</h2>
                </div>
                <div className={`${styles.colorSquarePanel} ${styles.blue}`}>
                    <h1 className={styles.mainHeadline}>Процедуры</h1>
                    <h2 className={styles.primaryHeadline}>{loading ? <LoadingBlock width="60px" height="28px" /> : formatNull(formInfo.count_cases)}</h2>
                    <p>Из них:</p>
                    <div className='buttonWithArrowRight'>
                        <p>{formatNull(formInfo.count_active_cases)} активных процедур (со статусом "В работе")</p>
                        <IconContainer Icon={ArrowRight} isClickable={false} onClick={() => {}} size = '16' color = 'rgb(68, 74, 255)' className = '' />
                    </div>
                </div>
            </div> */}
            <div className='horizontalContainer'>
                <div className='homePanel'>
                    {warning ? <WarningPanel text={warning} buttonText='Обновить' buttonAction={() => setReload(true)} />
                    :
                    <>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path fill='currentColor' d="M21,6H5c-.859,0-1.672-.372-2.235-.999,.55-.614,1.349-1.001,2.235-1.001H23c1.308-.006,1.307-1.995,0-2H5C2.239,2,0,4.239,0,7v10c0,2.761,2.239,5,5,5H21c1.657,0,3-1.343,3-3V9c0-1.657-1.343-3-3-3Zm-1,9c-1.308-.006-1.308-1.994,0-2,1.308,.006,1.308,1.994,0,2Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Баланс</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.balance < 0 && 'colorCell red'}`}>{formInfo.balance} ₽ (Членские взносы)</a>}
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.balance < 0 && 'colorCell red'}`}>{formInfo.special_balance} ₽ (Целевые взносы)</a>}
                        </div>
                    </div>

                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path fill='currentColor' d="m23.553,22.139l-2.666-2.666c.698-.981,1.113-2.177,1.113-3.473,0-3.314-2.686-6-6-6s-6,2.686-6,6,2.686,6,6,6c1.296,0,2.492-.415,3.473-1.113l2.666,2.666c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414Zm-8.226-3.142c-.601,0-1.204-.225-1.664-.674l-1.132-1.108c-.395-.387-.401-1.02-.015-1.414.386-.395,1.019-.401,1.414-.016l1.132,1.108c.144.142.379.141.522,0l2.713-2.624c.398-.381,1.032-.37,1.414.029.383.398.37,1.031-.029,1.414l-2.703,2.614c-.452.446-1.052.671-1.653.671Zm-7.327-2.997c0-4.411,3.589-8,8-8,1.458,0,2.822.398,4,1.083v-4.083c0-2.757-2.244-5-5-5H4.999C2.242,0,0,2.244,0,5.001v13.999c0,2.757,2.244,5,5,5h11c-4.411,0-8-3.589-8-8Zm2-11h5c.552,0,1,.447,1,1s-.448,1-1,1h-5c-.552,0-1-.447-1-1s.448-1,1-1Zm-4,12h-1c-.552,0-1-.447-1-1s.448-1,1-1h1c.552,0,1,.447,1,1s-.448,1-1,1Zm0-5h-1c-.552,0-1-.447-1-1s.448-1,1-1h1c.552,0,1,.447,1,1s-.448,1-1,1Zm0-5h-1c-.552,0-1-.447-1-1s.448-1,1-1h1c.552,0,1,.447,1,1s-.448,1-1,1Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Проверки за квартал</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_verifications > 0 && 'colorCell red'}`}>Найдено {formInfo.count_verifications}</a>}
                            <a className='aWithLink' onClick={() => navigate(`/account?section=verifications`, { state: { from: location.pathname + location.search + location.hash }})}>Перейти во вкладку "Проверки"</a>
                        </div>
                    </div>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path fill='currentColor' d="M10,18c0,.339,.028,.672,.069,1h-2.294l-4.479,2.669c-.634,.425-1.483,.445-2.162,.08-.7-.375-1.135-1.1-1.135-1.894V5C0,2.243,2.243,0,5,0h12c2.757,0,5,2.243,5,5v6.082c-1.178-.684-2.542-1.082-4-1.082-4.411,0-8,3.589-8,8Zm14,0c0,3.314-2.686,6-6,6s-6-2.686-6-6,2.686-6,6-6,6,2.686,6,6Zm-2,0c0-.553-.448-1-1-1h-3v-1.121c0-.355-.213-.676-.541-.812-.325-.135-.705-.062-.957,.19l-1.5,1.5c-.685,.685-.685,1.8,0,2.485l1.5,1.5c.251,.252,.629,.329,.957,.19,.328-.136,.541-.456,.541-.812v-1.121h3c.552,0,1-.447,1-1Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Административная ответственность</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_administrative > 0 && 'colorCell red'}`}>Найдено {formInfo.count_administrative}</a>}
                            <a className='aWithLink' onClick={() => navigate(`/account?section=administrative-responsibility`, { state: { from: location.pathname + location.search + location.hash }})}>Перейти во вкладку "Административная ответственность"</a>
                        </div>
                    </div>
                    </>}
                </div>
                <div className='homePanel'>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24"><path fill='currentColor' d="M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM12,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,5Zm-1,5h1a2,2,0,0,1,2,2v6a1,1,0,0,1-2,0V12H11a1,1,0,0,1,0-2Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Дисциплинарный комитет</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_disciplinaries > 0 && 'colorCell red'}`}>Найдено {formInfo.count_disciplinaries}</a>}
                            <a className='aWithLink' onClick={() => navigate(`/account?section=disciplinary-committee`, { state: { from: location.pathname + location.search + location.hash }})}>Перейти во вкладку "Дисциплинарный комитет"</a>
                        </div>
                    </div>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg id="Layer_1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path fill='currentColor' d="m14 7v-6.54a6.977 6.977 0 0 1 2.465 1.59l3.484 3.486a6.954 6.954 0 0 1 1.591 2.464h-6.54a1 1 0 0 1 -1-1zm8 3.485v8.515a5.006 5.006 0 0 1 -5 5h-10a5.006 5.006 0 0 1 -5-5v-14a5.006 5.006 0 0 1 5-5h4.515c.163 0 .324.013.485.024v6.976a3 3 0 0 0 3 3h6.976c.011.161.024.322.024.485zm-8 8.515a1 1 0 0 0 -1-1h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1zm3-4a1 1 0 0 0 -1-1h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Дата сдачи теоретического экзамена по подготовке арбитражных управляющих при Росреестре</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={isDatePastInMoscow(formInfo.date_am_exam, 1) ? 'colorCell red' : ''}>{formatDate(formInfo.date_am_exam)} {isDatePastInMoscow(formInfo.date_am_exam, 1) ? '[С последней даты выдачи свидетельства прошел год. Необходимо продлить свидетельство и указать новую дату выдачи]' : ''}</a>}
                            <a className='aWithLink' onClick={() => navigate(`/account?section=qualification`, { state: { from: location.pathname + location.search + location.hash }})}>Перейти во вкладку "Квалификация"</a>
                        </div>
                    </div>
                </div>
            </div>
            <WarningPanel
                text='Просмотрите рекомендации по безопасному взаимодействию с СРО'
                buttonText='Перейти' 
                buttonAction={() => navigate('/help#safety')} 
                type={'error'}
            />
        </div>
    )
}

export default AMHome;
